/**
 * @fileoverview Frontend application constants.
 * @summary Re-exports shared constants for frontend usage.
 *
 * @package KaraoNow
 * @module apps/front/src/config/constants
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 * @license EULA
 */

export {
  SubscriptionType,
  SUBSCRIPTION_PLANS,
  getPlanLimits,
  getPlanLimitsByString,
  type PlanLimits,
} from '@karaonow/shared'

/**
 * @summary Polling interval for real-time updates.
 * @description Used to automatically refresh queue and singers data on event pages.
 * Configurable via VITE_POLLING_INTERVAL_MS environment variable (in milliseconds).
 * Default: 5 minutes (300000 ms).
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 */
export const POLLING_INTERVAL_MS = import.meta.env.VITE_POLLING_INTERVAL_MS
  ? Number.parseInt(import.meta.env.VITE_POLLING_INTERVAL_MS, 10)
  : 5 * 60 * 1000 // Default: 5 minutes (300000 ms)

/**
 * @summary Admin dashboard URL for superadmin redirection.
 * @description URL of the admin dashboard application. Configurable via VITE_ADMIN_DASHBOARD_URL environment variable.
 * Default: https://admin.karaonow.com
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 */
export const ADMIN_DASHBOARD_URL = import.meta.env.VITE_ADMIN_DASHBOARD_URL || 'https://admin.karaonow.com'
  